import { ComponentBase } from '../../../component-base';
import { IMouseMove, IMouseRelease, IKeyDown, IDoubleClick } from '../Interfaces';
import { Injectable } from '@angular/core';

import { Line, PolyLine, ConnectionPoint } from '../object3D';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { SelectComponent } from './SelectComponent';

declare let THREE: any;

@Injectable()
export class DrawPolyLineComponent extends ComponentBase
  implements IKeyDown, IMouseMove, IMouseRelease, IDoubleClick {
  prevPos: any;

  private firstClick = true;
  private secondClick = false;
  private polyLine: PolyLine;
  private currentLine: Line;


  dblclick(e: MouseEvent): boolean {
    this.prevPos = null;
    const lastConnectionPoint = this.polyLine.children.find(
      c => c instanceof ConnectionPoint && c.currentLineId === this.currentLine.id
    );
    const connectionPoint = new ConnectionPoint(lastConnectionPoint.prevLineId, undefined);
    connectionPoint.position.copy(this.currentLine.position);
    this.polyLine.remove(this.currentLine);
    this.polyLine.remove(lastConnectionPoint);
    this.polyLine.add(connectionPoint);
    this.currentLine = null;
    this.firstClick = true;
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    return true;
  }

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
  }

  private snapPointToSaveNeededAngle(point, first) {
    const firstPoint = first.clone().setY(0);
    const lineLength = firstPoint.distanceTo(point.setY(0));
    let finalPoint = firstPoint.clone();
    for (let i = 0; i < 24; i++) {
      const angle = (Math.PI / 12) * i;
      const pPoint = new THREE.Vector3(Math.cos(angle), 0, Math.sin(angle));
      pPoint.setLength(lineLength);
      pPoint.add(firstPoint);
      if (point.distanceTo(pPoint) < point.distanceTo(finalPoint)) {
        finalPoint = pPoint;
      }
    }
    return finalPoint;
  }

  mouseUp(e: MouseEvent) {
    let position = this.positionCalculator.calculate(e);
    if (this.firstClick) {
      this.firstClick = false;
      this.polyLine = new PolyLine();
      this.polyLine.position.copy(position);
      this.drawings.canvas.add(this.polyLine);
      this.secondClick = true;
    } else {
      this.secondClick = false;
    } 
    const prevLineId = this.currentLine ? this.currentLine.id : undefined;
    this.polyLine.updateMatrixWorld();
    this.polyLine.worldToLocal(position).setY(0);
    if (this.prevPos) {
      position = this.prevPos;
    }
    this.currentLine = new Line();
    this.currentLine.position.copy(position);
    this.polyLine.add(this.currentLine);
    const connectionPoint = new ConnectionPoint(prevLineId, this.currentLine.id);
    connectionPoint.position.copy(position);
    this.polyLine.add(connectionPoint);
    return true;
  }

  mouseMove(e: MouseEvent) {
    let result = false;
    const { currentLine } = this;
    if (currentLine) {
      let position = this.positionCalculator.calculate(e);
      this.polyLine.updateMatrixWorld();
      this.polyLine.worldToLocal(position);
      const currentAngle = Math.atan(
        (position.z - currentLine.position.z) / (position.x - currentLine.position.x)
      );
      if (!e.shiftKey && (currentAngle % Math.PI) / 12 !== 0) {
        position = this.snapPointToSaveNeededAngle(position, currentLine.position);
      }
      this.prevPos = position;
      currentLine.update(currentLine.position, position.setY(0));
      result = true;
    }
    return result;
  }

  keyDown(e: KeyboardEvent) {
    const isEscKey = e.keyCode === 27;
    let result = false;
    if (isEscKey) {
      if (this.secondClick) {
        this.drawings.canvas.remove(this.polyLine);
        this.secondClick = false;
      }
      this.prevPos = null;
      const lastConnectionPoint = this.polyLine.children.find(
        c => c instanceof ConnectionPoint && c.currentLineId === this.currentLine.id
      );
      const connectionPoint = new ConnectionPoint(lastConnectionPoint.prevLineId, undefined);
      connectionPoint.position.copy(this.currentLine.position);
      this.polyLine.remove(this.currentLine);
      this.polyLine.remove(lastConnectionPoint);
      this.polyLine.add(connectionPoint);
      this.currentLine = null;
      this.firstClick = true;
      result = true;
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawPolyLineComponent.ts